import { computed, makeObservable } from 'mobx';
import { RELEASE_NOTES_CONTENT } from '../modules/release.notes.popup/release.notes.content';
import type { ReleaseNote } from '../modules/release.notes.popup/release.notes.types';
import { type IkeClientService, Services } from './index';

export const MAX_RELEASES = 5;

export class ReleaseNotesService implements IkeClientService {
	readonly __priority = 100;

	constructor() {
		makeObservable(this);
	}

	get releases(): ReleaseNote[] {
		return RELEASE_NOTES_CONTENT.releases.slice(0, MAX_RELEASES);
	}

	get latestVersion(): string | null {
		const [latest] = this.releases;
		return latest != null ? latest.version : null;
	}

	@computed get hasUnreadReleaseNotes(): boolean {
		if (Services.User.current == null || this.latestVersion == null) {
			return false;
		}
		return Services.UserSettings.lastViewedReleaseNotesVersion !== this.latestVersion;
	}

	markAsViewed(): Promise<void> {
		if (this.latestVersion == null) {
			return Promise.resolve();
		}
		return Services.UserSettings.setLastViewedReleaseNotesVersion(this.latestVersion).then((): void => undefined);
	}
}
